import { AbstractQuery } from 'src/models/query';

export class NoteQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_Task_GetTheDetailsForTheTaskQuery';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}
